export const hk = {
  store: "商店",
  meal: "餐點",
  users: "用戶",
  user: "用戶",
  layout: "佈局",
  analytics: "分析",
  settings: "設置",
  storeDetails: "商店信息",
  advanced: "更多設置",
  name: "名字",
  quantity: "量",
  address: "地址",
  email: "郵件地址",
  phone: "電話",
  galleryForCustomer: "顧客顯示廣告/圖片庫",
  customMealCategory: "自定義餐點類別",
  storeType: "商店類型",
  currency: "貨幣",
  add: "添加",
  print: "打印",
  sessions: "訪問",
  orders: "訂單",
  customerFacingScreen: "顧客顯示",
  cashierView: "收銀員顯示",
  kitchenView: "廚房顯示",
  layoutView: "佈局顯示",
  history: "訂單記錄",
  noOrderRecordsExist: "不存在訂單記錄",
  noSessionRecordsExist: "不存在訪問記錄",
  updateMenu: "更新菜單",
  updateMenuSuccessfully: "成功更新菜單",
  updateMenuTooltip: "每次修改餐點後點擊此處以將最新菜單上傳",
  serving: "服務中",
  active: "使用中",
  inactive: "未用",
  amount: "數量",
  total: "總數",
  table: "餐桌",
  payment: "支付",
  changeDue: "找回",
  printReceipt: "打印收據",
  closingBillSentToRevenuQuebec: "{channel} / {count}. 結賬單將發送至魁北克稅務局，即將打印。",
  temporaryBillSentToRevenuQuebec: "{channel} / {count}. 這是臨時賬單。收據將在魁北克稅務局回覆後打印。",
  cancel: "取消",
  complete: "完成",
  edit: "更改",
  delete: "刪除",
  update: "更新",
  deleteOrder: "刪除訂單",
  printOrderSlip: "打印訂單",
  printKitchenSlip: "打印廚房紙條",
  latestOrderAt: "最新提交於",
  completedAt: "完成於",
  received: "收到於",
  startEditing: "開始編輯",
  save: "保存",
  addSmallDiningTable: "添加小餐桌",
  addMediumDiningTable: "添加中型餐桌",
  addLargeDiningTable: "添加大餐桌",
  clearAll: "清除",
  undo: "撤消",
  reorder: "重新排序",
  renew: "开台",
  renewSession: "重新开台",
  createNewSession: "新开台",
  addSession: "添加台",
  createSession: "添加新台",
  printSession: "打印二維碼",
  takeOrder: "點餐",
  editOrder: "更改餐點訂單",
  completeOrder: "完成交易",
  description: "簡介",
  ingredients: "配料",
  price: "價格",
  category: "分類",
  createdDate: "創建日期",
  lastUpdated: "最新更改日期",
  lastUpdatedAt: "最新更新於",
  admins: "管理員",
  members: "成員",
  member: "成員",
  admin: "管理員",
  invited: "邀請",
  owner: "所有者",
  adminsTooltip: "只有超級管理員(商店所有者)可以更改其他管理員權限",
  membersTooltip: "成員只可以查看和管理客戶的訂單。",
  invitedTooltip: "被邀請的成員在接受邀請後將被賦予成員權限",
  invitedPeople: "待接受邀請",
  transferOnwership: "轉讓所有權",
  removeAdminRole: "撤銷管理員權限",
  grantAdminRole: "授予管理員權限",
  invitePeople: "邀請",
  addStore: "添加商店",
  alreadyExists: "已經存在",
  existingInvitationTo: "待邀請郵件",
  emailIsRequired: "必須填寫郵件地址",
  nameIsRequired: "必須填寫名字",
  priceIsRequired: "必須填寫價格",
  invalidEmailAddress: "郵件地址無效",
  fullService: "完整服務",
  limitedService: "有限服務",
  storeTypeDescription:
    "更改商店類型將影響收營員顯示訂單排列的方式以及訂單的完成方式",
  limitedServiceDescription:
    "有限服務的訂單管理方式為每一次提交即一個訂單(e.g. 飲料店，美食廣場攤位）",
  fullServiceDescription:
    "完整服務的訂單管理方式為每一個餐桌/訪問即一個訂單(e.g. 餐廳，咖啡廳）",
  fullServiceExplain:
    "完整服務提供完整的用餐體驗，顧客通常在用餐完畢後付款。(e.g. 餐厅，咖啡厅）",
  limitedServiceExplain:
    "有限服務通常會在點餐後或上菜時即可付款。(e.g. 飲料店，美食廣場攤位）",
  orderIsEmpty: "已無訂單記錄",
  completedByKitchen: "廚房已完成",
  changeMealImage: "更換餐點圖片",
  uploadMealImage: "上傳餐點圖片",
  food: "食物",
  drink: "飲料",
  side: "小菜",
  submitted: "提交於",
  confirmDeleteMeal: "確認刪除此餐點?",
  confirmRenewSession: "訪問仍然有效，確認更新此訪問?",
  confirmCompleteOrder: "確認完成此訂單?",
  confirmDeleteSession: "確認刪除此訪問?",
  confirmDeleteImage: "確認刪除此圖片?",
  storeInvitation: "商店邀請",
  noInvitationFound: "未發現邀請，請通知商店管理員",
  join: "加入",
  joinStore: "加入商店",
  settingUpStore: "創立自己的商店",
  createStore: "創立商店",
  invitation: "商店邀請",
  uploadProfilePicture: "上傳頭像",
  changeProfilePicture: "更換頭像",
  myStores: "我的商店",
  profile: "個人資料",
  accountSettings: "賬號設置",
  signOut: "登出",
  deleteStore: "刪除商店",
  cloneStore: "複製商店",
  uploadImage: "上傳圖片",
  temporarySession: "暫時性(訪問將在24小時後過期)",
  deleteSessionOnCompletion: "每次訂單完成後刪除訪問",
  autoRenew: "自動更新訪問（需先刪除訪問）",
  limitedServiceSession:
    "為了配合有限服務的操作，訪問將不會過期或被刪除，更改下方的設置以匹配商店的運營方式",
  noExistingNameFound: "在這裡添加訪問，然後於",
  ifYouWantLink: "添加餐桌以鏈接訪問至佈局顯示",
  noOptions: "沒有選項",
  addCustomerGallery: "添加圖片",
  grantAdminRoleToast: "已被賦予[管理員]權限",
  removeAdminRoleToast: "已被撤銷[管理員]權限",
  deleteInvitationToast: "已被移除",
  deleteMemberToast: "已被移除",
  deleteAdminToast: "已被移除",
  transferOnwershipToast: "成功轉移商店所有人至",
  sendInvitationToast: "邀請成功發送至",
  switchedStoreToast: "切換至",
  deleteStoreToast: "成功刪除",
  recommendItToCustomer: "推薦給顧客",
  emailUs: "電郵詢問",
  emailUsShort: "電郵詢問",
  signup: "註冊",
  login: "登錄",
  quitStore: "退出商店",
  switchToStore: "切換到此商店",
  changeLogo: "更換標誌",
  uploadLogo: "上傳標誌",
  emailVerifiedToast: "您的電郵地址已經過驗證",
  emailSentToast: "電郵已發送！",
  emailSentToastDescription: "請檢查您的郵箱以進行驗證",
  emailVerificationErrorToast: "驗證郵件已發送",
  emailVerificationFailedToast: "發送驗證郵件失敗",
  resetPasswordToast: "請查看您的電子郵件以重置密碼",
  emailNotExist: "電郵地址不存在",
  failedToUpload: "上傳失敗",
  saveLayoutToast: "餐桌佈局已更新",
  invalidEmailOrPassword: "電郵地址或密碼無效",
  failedToLogin: "登錄失敗",
  verificationEmailSent: "驗證您的電子郵件",
  verficiationEmailSentDescription:
    "完成帳戶註冊前，必須先驗證該電子郵件地址屬於您。",
  emailAlreadyExist: "電郵地址已經存在",
  successfullyCreateStore: "成功創建商店",
  pleaseSwitchStore: ",請切換到您的新商店。",
  pleaseCreateMeal: ",請繼續為您的商店創建餐點。",
  youAreNowMemberOf: "你已加入",
  orderFromTable: "餐桌",
  isCompleted: "已完成",
  addedCategory: "添加分類",
  removedCategory: "刪除分類",
  currencyChanged: "貨幣已更改為",
  successfullyUpdateStore: "成功更新商店",
  storeTypeChanged: "已更改商店類型為",
  layoutNotReady: "未設置餐廳佈局...",
  layoutNotReadyDescription: "尚未創建餐廳佈局，請先前往佈局頁面創建",
  createLayout: "創建餐廳佈局",
  confirmQuitStore: "确认退出商店?",
  minimumItemQuantity: "點餐數量最小小數值",
  noMoreOrder: "已沒有更多記錄",
  loadMore: "更多記錄",
  id: "ID",
  notifications: "通知",
  noNotificationFound: "未發現任何通知",
  allowMemberEdit: "讓成員更改訂單",
  storeCreated: "成功創建商店",
  storeCreatedNotification: "成功創建商店, 請繼續為您的商店創建餐點。",
  manageSubscription: "訂閱管理",
  billing: "計費",
  currentSubscription: "當前訂閱",
  mySubscription: "我的訂閱",
  initiateSubscription: "如果您是店主，請先創建商店。",
  selectYourStoreType: "選擇您的商店類型",
  configureStoreTypeInfo: "如果您不確定要選擇哪個，可以稍後重新配置商店類型。",
  compulsoryItem: "自動添加並無法更改數量",
  compulsory: "為必須選項",
  yes: "是",
  no: "否",
  hiddenFromMenu: "從菜單中隱藏",
  dashboard: "儀錶盤",
  addedPaymentMethod: "添加付款方式",
  removedPaymentMethod: "删除付款方式",
  paymentMethod: "付款方式",
  paymentMethods: "付款方式",
  options: "選項",
  summarized: "總結",
  unit: "单位",
  unitPlaceHolder: "單位用於顯示(e.g.,克,公斤,碗)",
  totalAmount: "總金額",
  checkout: "提交",
  back: "返回",
  close: "關閉",
  remark: "备注",
  orderSettings: "訂單",
  paymentKitchenOrder: "先送餐/先付款",
  paymentFirst: "先付款",
  servedFirst: "先送餐",
  alwaysCompleteAtKitchenView:
    "由於您的商店運行先付款模式,所以請在在每一次交易完成後前往廚房顯示中完成每一次訂單",
  paymentFirstWarning: "在提供完整服務下選擇先付款方式可能會導致錯誤行為",
  paymentKitchenExplained:
    "選擇先付款模式以避免訂單在付款後被移除，這將幫助您的員工在付款後任可閱讀廚房信息。（例如備餐配料）",
  tableName: "訪問/佈局餐桌名稱",
  storeOperation: "商店運營",
  sessionControl: "訪問控制",
  all: "完整",
  simple: "簡單",
  sessionControlExplained:
    "使用 [簡單] 訪問控制後，您將無法在 [收營員顯示] 內 [添加新訪問]、[刪除訪問]、[更新訪問] 以及 [打印訪問] , 所以請在更改為 [簡單] 訪問控制前設定好所有訪問配置。",
  none: "無",
  nearest: "四捨五入",
  up: "向上",
  down: "向下",
  roundingTotal: "訂單總額進位",
  roundingItem: "個別餐點價格進位",
  changeTo: "更換至",
  allSessionControl: "完整訪問控制",
  simpleSessionControl: "簡單訪問控制",
  requiredTableName: "要求員工/客戶在提交時填寫餐桌名(與佈局餐桌無關)",
  pleaseInsertTableName: "請填寫餐桌名稱",
  session: "訪問",
  inheritFromStore: "繼承商店設置",
  customerScreen: "顧客視角",
  recentOrders: "最近的訂單",
  standard: "標準",
  standardMenuControl: "標準菜單模式",
  simpleMenuControl: "簡單菜單模式",
  menuControl: "員工點餐模式",
  completePaymentFirstAlert: "此訂單未完成付款,請先在[收銀員顯示]完成付款",
  detail: "詳情",
  detailNotExists: "訂單詳情已不存在",
  addedRemarkShortcut: "添加備註快捷鍵",
  removedRemarkShortcut: "刪除備註快捷鍵",
  remarkShortcuts: "備註快捷鍵",
  paymentMethodNameIsRequired: "必須填寫付款方式",
  paymentMethodAlreadyExisted: "付款方式已經存在",
  categoryNameIsRequired: "必須填寫類別名稱",
  categoryAlreadyExisted: "類別已經存在",
  shortcutNameIsRequired: "必須填寫快捷鍵名稱",
  shortcutAlreadyExisted: "快捷鍵已經存在",
  shortcut: "快捷鍵",
  createOption: "添加選項",
  optionName: "選項名稱",
  requireChange: "付款時需計算找錢",
  menuSettings: "菜單",
  paymentSettings: "付款",
  submittingOrder: "正在提交...",
  submittedOrder: "成功提交!",
  addMeal: "添加餐點",
  createdFirstMeal: "成功添加餐點",
  pleaseUpdateMenu:
    "成功創建了第一份餐點，完成所有餐點設置後請點擊這裡以更新菜單",
  pleaseCreateSession: "請前往[收銀員顯示]页面創建第一個訪問/餐桌",
  storeSetupComplete: "成功添加訪問",
  moreStoreConfiguration:
    "點擊二維碼點餐,或打印二維碼讓顧客掃碼點餐。更多的商店配置，請前往[設置]改動以更符合您的商店操作",
  ok: "知道了",
  others: "其他",
  features: "功能顯示",
  kitchen: "廚房顯示",
  hasBeen: "已被",
  enabled: "啟用",
  disabled: "關閉",
  untickToDisable: "取消勾選以關閉功能",
  printAfterCompletion: "訂單完成後打印",
  userDecide: "用戶決定",
  alreadyAMember: "已經有賬號了嗎?",
  sign_up: "註冊",
  log_in: "登錄",
  password: "密碼",
  confirmPassword: "確認密碼",
  passwordMustBe6: "密碼必須至少6個字符長",
  required: "必須填寫",
  passwordUnmatched: "密碼不匹配",
  forgotPassword: "忘記密碼了?",
  OR: "或",
  signInWithGoogle: "使用谷歌賬號登錄",
  forgotPasswordInfo: "您將收到一封帶有重置鏈接的電子郵件",
  resetPassword: "重設密碼",
  verifyYourEmail: "驗證您的電子郵件地址",
  check: "檢查",
  toVerify: "以驗證您的賬戶並開始使用",
  ifYouHaveNotReceived: "如果幾分鐘後您還沒有收到郵件,請檢查您的垃圾郵件箱",
  resendVerificationEmail: "重新發送驗證郵件",
  refresh: "刷新",
  startNow: "開始吧",
  freeUnlimitedUsers: "免費，無限用戶",
  etilhubDescription: "加入精簡的 POS 提升方案，更有效地經營您的餐飲業務。",
  cloudSmart: "雲端|智能",
  pointOfSale: "餐飲管理系統",
  registerForFree: "免費註冊",
  qrFoodOrdering: "掃碼點餐",
  contactlessOrders: "免接觸點餐服務",
  instantAndEasySetup: "簡單快速設置",
  adjustableForEveryBusiness: "可針對每種餐飲模式進行調整",
  billingProcessingPrinting: "賬單處理及打印",
  orderSlipPrinting: "打印客戶訂單",
  issueReceipt: "打印收據",
  sessionQRPrinting: "打印點餐二維碼",
  instantKitchenView: "即時廚房視圖",
  realtimeOrderStatus: "實時訂單狀態",
  orderQueue: "訂單隊列",
  ingredientsDisplay: "配料顯示",
  customizableFloorPlan: "可製定餐廳平面圖",
  restaurantTableLayout: "餐廳餐桌佈局",
  realtimeTableStatus: "實時餐桌狀態",
  intuitiveInterface: "直觀的操作界面",
  moreFeatures: "更多功能",
  comingsoon: "即將推出...",
  noItemExist: "不存在餐點記錄",
  myStore: "我的商店",
  logout: "登出",
  navigationSettings: "導航設置",
  navigateToPaymentAfterSubmit: "訂單提交後導航至付款 (收銀員顯示)",
  size: "體積",
  small: "小",
  medium: "中",
  large: "大",
  tableNameMustBeSame:
    "餐桌名稱必須與訪問名稱相同, 可先在這裡添加餐桌再前往商店添加訪問。",
  confirmDeleteStore: "通過輸入商店名字以確認您要刪除該商店:",
  deleteThisStore: "刪除此商店?",
  deleteStoreWarning: "這樣做將永久刪除商店，並且無法恢復。",
  pleaseInsertStoreName: "請輸入商店名字",
  cloneThisStore: "複製商店",
  cloneStoreInfo: "輸入新商店的資料",
  addIngredient: "添加配料",
  orderUpdatedAt: "訂單更新於餐桌",
  simpleMenuInfo: "在簡單菜單模式下無法在一個訂單內選擇多個餐點選項",
  fiverr: "Fiverr",
  bySigningUp: "登錄或完成註冊即表示你同意",
  privacyPolicy: "隱私政策",
  termsAndConditions: "用戶協議",
  and: "和",
  storeExceedSubscriptionLimit:
    "商店數量超過訂閱限制,升級您的訂閱以添加更多商店。",
  someStoreIsNotShowing: "由於您的訂閱已到期，某些商店未被顯示。",
  currentPeriodStart: "訂閱週期開始於",
  currentPeriodEnd: "訂閱將更新於",
  planCanceledOn: "訂閱將取消於",
  storeQuantity: "商店數量",
  dailyOrder: "每日訂單限制",
  perStore: "單個商店",
  createdBy: "創建者",
  completedBy: "完成者",
  monday: "星期一",
  tuesday: "星期二",
  wednesday: "星期三",
  thursday: "星期四",
  friday: "星期五",
  saturday: "星期六",
  sunday: "星期日",
  morePrices: "選項中有其他價格",
  moreIngredients: "選項中有其他配料",
  all_: "全部",
  filter: "過濾",
  expired: "過期",
  updated: "已更新",
  limitTime: "限时",
  limitDay: "限日",
  outOfStock: "已售罄",
  startFrom: "開始於",
  endAt: "結束於",
  hour: "小時",
  hours: "小時",
  default: "默認",
  cloud: "云端",
  printMethod: "打印方式",
  sessionCreated: "創建訪問",
  orderCreated: "創建訂單",
  event: "事件",
  eventDescription: "選擇觸發webhooks的事件類型",
  endPointDescription: "輸入用以接收 webhooks 的 URL",
  webhookDescription:
    "我們將向此 URL 提交一個 POST 請求, 該請求包含您選擇觸發的事件的所有數據(JSON 對象)",
  testEndpointUrl: "測試端點URL",
  failedToPrint: "打印失敗",
  secretKeyDescription:
    "密鑰將被用於與 HTTP 負載進行計算HMAC-SHA256哈希值,並包含在名為 X-Hub-Signature 的標頭中",
  outGoingWebhooks: "Outgoing Webhooks",
  urlIsRequired: "必須填寫URL",
  invalidUrl: "URL無效",
  endpointUrl: "Endpoint URL",
  addWebhook: "添加 Webhook",
  confirmDeleteWebhook: "確認刪除 webhook?",
  printButtonClick: "廚房",
  takeOrderforTable: "點單",
  addGuestNumber: "添加客人數量",
  customerScreen: "顧客螢幕",
  orderHistory: "訂單歷史",
  endSession: "关台",
  orderNow: "點單",
  viewMenu: "看菜單",
  adults: "成人",
  kids: "小孩",
  seniors: "老人",
  other: "其他",
  all:"全部",
  leaveWarning:"您確定要離開嗎？ 您所做的變更可能不會儲存",
  personAtTable: "人正在點餐，桌號",
  bePatient: "請耐心等待。",
  checkMenu: "請查看菜單",
  cloneItem: "克隆商品",
  language: "語言",
  itemPrintName: "列印項目名稱",
  serviceFee: "服務費",
  salesReport: "銷售報告",
  chatPrint: "列印聊天",
  send: "發送",
  openChatPrint: "開啟聊天列印",
  deleteCategory: "刪除分類",
  deleteCategoryConfirmation: "確定要刪除此分類嗎？",
  categoryName: "分類名稱",
  deleteCategoryWarning: "警告：此操作無法撤銷",
  cannotDeleteCategoryWithItems: "無法刪除包含商品的分類",
  totalItems: "總商品數",
  itemsInCategory: "分類中的商品",
  pleaseRemoveItemsFirst: "請先移除商品",
  deletionFailed: "刪除失敗",
  categoryDeleted: "分類已刪除",
  categorySuccessfullyDeleted: "分類刪除成功",
  errorDeletingCategory: "刪除分類時發生錯誤",
  anErrorOccurred: "發生了一個錯誤",
  categoryAll: "全部",
  loadingSession: "加载会话...",
  sessionInvalid: "会话无效",
  loadingMenu: "加载菜单...",
  mergeTables: "合併餐桌",
  selectTablesToMerge: "選擇要合併的餐桌",
  selectedTables: "已選餐桌",
  primary: "主要",
  active: "使用中",
  cannotRemove: "無法移除",
  primaryTableRequired: "無法移除主餐桌",
  add: "添加",
  applyMerge: "應用合併",
  invalidTables: "無效餐桌",
  noActiveOrders: "沒有活動訂單",
  enterYourName: "請輸入您的姓名",
  continue: "繼續",
  othersOrdering: "歡迎加入！",
  nameRequired: "需要姓名",
  pleaseEnterName: "請輸入您的姓名以繼續",
  error: "錯誤",
  somethingWentWrong: "出現了問題",
  welcomeBack: "歡迎回來",
  pleaseWait: "請稍等",
  sessionCheckInProgress: "會話檢查進行中",
  noSuchTable: "抱歉，沒有這個桌子！",
  waitingForStaff: "等待服務員為您開桌...",
  scanQRCodeAgain: "請再次掃描二維碼以點餐或查看菜單！",
  bonAppetit: "祝您用餐愉快！",
  modalSelectLanguage: "選擇語言",
  sessionNotProvided: "未提供會話",
  noStoreIdProvided: "會話中沒有商店ID",
  storeNotConfigured: "找不到商店",
  failedToLoadData: "加載數據失敗",
  orderNumber: "訂單 #",
  orderCreated: "創建於",
  orderTotal: "訂單總計",
  totalWithTaxes: "含稅總計",
  customerName: "姓名",
  totalFor: "總計",
  noOrders: "無訂單",
  grandTotal: "總金額",
  pastOrders: "歷史訂單",
  poweredBy: "技術支持",
  closeButton: "關閉",
  thisSelectionIsRequired: "此選擇為必填項",
  pleaseSelectAtLeast: "請至少選擇",
  maximumSelections: "最多",
  selectionsAllowed: "個選擇",
  optionItems: "個選項",
  customizeYourOrder: "定制您的訂單",
  totalExtra: "額外費用",
  cancelButton: "取消",
  addToCart: "加入購物車",
  selectExactly: "您需要選擇恰好",
  singleItem: "項",
  selectRange: "選擇",
  rangeTo: "至",
  selectAtLeast: "至少選擇",
  selectUpTo: "最多選擇",
  selectMultipleOptional: "多選（可選）",
  selectOneRequired: "單選（必選）",
  requiredOption: "必填",
  
  // TableRedirect translations
  invalidStoreId: "無效的商店ID",
  tableRedirectStoreNotFound: "找不到商店",
  tableRedirectError: "出現了問題，請重試。",
  loadingTable: "正在查找您的餐桌...",
  fixedTableQrDisabled: "此商店已禁用固定餐桌二維碼。",
  contactStaffForHelp: "請聯繫工作人員尋求幫助"
};
